<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div class="row">
      <div class="col-md-12" v-if="inputs.attach_complaint_document_oec && inputs.attach_complaint_document_oec.length > 0">
        
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">MIEMBRO</th>
              <th scope="col" class="text-center">TIPO DE EQUIPO</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value, key) in inputs.complaint_commission_members"
              :key="key"
            >
              <td class="align-middle">
                {{ value.user.full_name }}
              </td>
              <td class="align-middle text-center">
                {{ 'Comisión de Queja' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosGet } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
name: "MembersCommissionComplaint",
  mixins: [FormMixin],
  props: {
    id: String,
    dgc_complaint_document: Object,
    area_director_complaint_document: Object,
    analysis_complaint_document: Object,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let url = `complaints/commissionComplaintDocuments/${this.$store.state.evaluatorReview.evalTestId}`;
      axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
    },
    
  },
};
</script>
